import axios from '../axios';
import { Format } from '../phone';
import { GetPageRequestID } from './pagerequests';
import { UserDetails } from './users';

interface createOrderOptions {
    userDetails?: UserDetails;
    amount?: string;
    orderIDs: string[];
    successURL: string;
    cancelURL: string;
}

declare interface paypalOrderResponse {
    url: string;
}

export async function CreateOrder(opts: createOrderOptions): Promise<string> {
    return axios.post<paypalOrderResponse>('/paypal/orders', {
        'user': opts.userDetails ? {
            ...opts.userDetails,
            'phone': Format(opts.userDetails.phone),
            'pageRequestID': await GetPageRequestID(),
            'tz': Intl.DateTimeFormat().resolvedOptions().timeZone,
        } : undefined,
        'orderIDs': opts.orderIDs,
        'amount': opts.amount,
        'successURL': opts.successURL,
        'cancelURL': opts.cancelURL,
    }).then(resp => resp.data.url);
}